import { queryOptions, useQuery } from '@tanstack/react-query'
import dayjs from 'dayjs'

import { intentionApi } from '../../intention/api/intentionApi'

export const getStreakWatchmanOptions = () => {
  const from = dayjs().subtract(7, 'day').format('YYYY-MM-DD')
  const to = dayjs(new Date()).format('YYYY-MM-DD')
  return queryOptions({
    queryKey: ['watchman_streak', from, to],
    queryFn: ({ signal }) => intentionApi.getStreaksWatchman({ from, to, orderBy: 'asc' }, { signal }),
    retry: 0,
    staleTime: 60 * 1000 * 10, // 10 minutes
  })
}

export const useStreakWatchmanQuery = () => useQuery(getStreakWatchmanOptions())
